module.exports = __webpack_public_path__ + "static/media/14_l_holsti2_6.61_62.69.9a38cf5f.png";